<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý model sản phẩm</div>
      </div>
      <div class="card card-w-title">
        <div class="box-top-list">
          <span class="p-m-0">Lịch sử model sản phẩm</span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
          </span>
        </div>
        <div class="list-data">
          <TabView >
            <TabPanel  :key="'0'"   header="Thông tin chung" >
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-md-6">
              <div class="p-field p-col-12">
                <div class="p-col-8">
                  <label for="model_code">Model sản phẩm <span class="error">*</span></label>
                  <InputText id="model_code" type="text" disabled="true" v-model="model_code" />
                </div>
              </div>
              <div class="p-field p-col-12">
                <div class="p-col-8">
                  <label for="name">Tên sản phẩm  <span class="error">*</span></label>
                  <InputText disabled="true" id="name" type="text" v-model="name" />
                </div>
              </div>
              <div class="p-field p-col-12">
                <div class="p-col-8">
                  <label for="category_id">Nhóm sản phẩm <span class="error">*</span></label>
                  <Dropdown :disabled="true" inputId="category_id" v-model="category_id" :options="optionsCategories" optionLabel="label"  optionValue="value"/>
                </div>
              </div>

              <div class="p-field p-col-12">
                <div class="p-col-8 p-md-0 p-grid">
                  <div class="p-col-6">
                    <div class="p-field">
                      <label for="warranty_time">Thời hạn bảo hành  <span class="error">*</span></label>
                      <div class="p-grid">
                        <div class="p-col-8 p-field">
                          <InputText disabled="true" id="warranty_time" type="text" v-model="warranty_time"/>
                        </div>
                        <div class="p-col-3 p-field unit-custom">
                          <label >Tháng</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="p-col-6">
                    <div class="p-field">
                      <label for="change_time">Thời hạn đổi</label>
                      <div class="p-grid">
                        <div class="p-col-8 p-field">
                          <InputText disabled="true" id="change_time" type="text"  v-model="change_time"/>
                        </div>
                        <div class="p-col-3 p-field unit-custom">
                          <label >Ngày</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="p-col-6">
                    <div class="p-field">
                      <label for="returnable_time">Thời hạn trả (tự duyệt)</label>
                      <div class="p-grid">
                        <div class="p-col-8 p-field">
                          <InputText disabled="true" id="returnable_time" type="text"  v-model="returnable_time"/>
                        </div>
                        <div class="p-col-3 p-field unit-custom">
                          <label >Ngày</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="p-col-6">
                    <div class="p-field">
                      <label for="returnable_appraisal_time">Thời hạn trả (thẩm định)</label>
                      <div class="p-grid">
                        <div class="p-col-8 p-field">
                          <InputText disabled="true" id="returnable_appraisal_time" type="text"  v-model="returnable_appraisal_time"/>
                        </div>
                        <div class="p-col-3 p-field unit-custom">
                          <label >Ngày</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-field p-col-12">
                <div class="p-col-8">
                  <label for="production_status">Trạng thái sản xuất <span class="error">*</span></label>
                  <Dropdown :disabled="true" inputId="production_status" v-model="productionStatus" :options="optionStatus" optionLabel="label"  optionValue="value" />
                </div>
              </div>
            </div>
           
            <div class="p-md-6">
              <div class="p-field p-col-12 display-none">
                <div class="p-col-8">
                  <label for="description">Mô tả</label>
                  <Textarea disabled="true" id="description" rows="5"  v-model="description"/>
                </div>
              </div>
              <div class="p-field p-col-12">
                <div class="p-col-8">
                  <label for="zip">Mẫu QR Code <span class="error">*</span></label>
                  <Dropdown :disabled="true"  v-model="qr_code_size" :options="qrCodeSizes" optionLabel="label" optionValue="value"/>
                  <div class="box-qrcode-product">
                    <templateSerialNumber class="custom-qr-code" :title="title" :note="note" :hotline="hotline" :codeValue="$myConstants.getUrlChecker() + '/check-warranty-detail/' + serialNumber" :modelCode="model_code" :serialNumber="serialNumber"/>
                  </div>
                </div>
              </div>
              <div class="p-field p-col-12">
                <div class="p-col-8">
                  <label for="lastname">Hình ảnh sản phẩm</label>
                  <div class="box-img-product">
                    <img v-if="productImages != null && productImages != ''" :src="productImages" width="200"/>
                    <img v-else  :src="logoPortal" width="200"/>
                  </div>
                </div>
              </div>
              <div class="p-field p-col-12" style="padding-bottom: 0px !important;">
                <p style="font-weight: bold;margin-bottom: 0px;">Hướng dẫn sử dụng</p>
              </div>
              <div class="p-field p-col-12">
                <div class="p-col-8">
                  <label for="name">Link PDF</label>
                  <InputText :disabled="true"   id="link_pdf" type="text" v-model="link_pdf" maxlength="500"/>
                </div>
              </div>
              <div class="p-field p-col-12">
                <div class="p-col-8"  >
                  <label for="name">Link Youtube</label>
                  <InputText :disabled="true"  id="link_youtube" type="text" v-model="link_youtube" maxlength="500"/>
                </div>
              </div>
            </div>
          </div>
            </TabPanel>
            <TabPanel header="Bảo trì định kỳ" >
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-md-6">
                  <div class="p-field p-col-12">
                    <div class="p-col-8">
                      <label >Áp dụng bảo trì định kỳ <span class="error">*</span></label>
                      <Dropdown :disabled="true" v-model="is_maintenance" :options="$dataCommon.LIST_APPLY_MAINTENANCE" optionLabel="name"  optionValue="value" />
                    </div>
                  </div>
                </div>
                <div class=" p-md-6" v-if="is_maintenance == 1">
                  <div class="p-field p-col-12">
                    <div class="p-col-8 p-offset-4">
                      <label >Loại bảo trì <span class="error">*</span></label>
                      <Dropdown :disabled="true" v-model="type_maintenance" :options="$dataCommon.LIST_TYPE_MAINTENANCE" optionLabel="name" optionValue="value" placeholder="Chọn loại bảo trì"/>
                      <!--<small v-if="validationErrors && validationErrors['type_maintenance']"
                             class="p-invalid" >{{validationErrors['type_maintenance']}}</small>-->
                    </div>
                  </div>
                </div>
                <div class=" p-md-12" v-if="is_maintenance == 1">
                  <div class="p-field p-col-12 table_maintenance">
                    <DataTable
                        dataKey="id"
                        class="p-datatable-responsive "
                        :scrollable="(object_maintenance.scrollHeight !== '' ? true : false) "
                        :scrollHeight="object_maintenance.scrollHeight"
                        :autoLayout="true"
                        :value="object_maintenance.list_data"

                    ><!--responsiveLayout="scroll"-->
                      <Column
                          :bodyStyle="'width: 110px;'"
                          :headerStyle="'width: 110px;'"
                          :headerClass="object_maintenance.headerClass"
                          field="parts_number" header="Đợt bảo trì">
                        <template #body="slotProps">
                          <div >
                            Đợt {{slotProps.data.parts_number}}
                          </div>
                        </template>
                      </Column>
                      <Column
                          :bodyStyle="'width: 170px;text-align: center;'"
                          :headerStyle="'width: 170px;text-align: center;'"
                          :headerClass="object_maintenance.headerClass"
                          field="time_between_maintenance" header="Khoảng thời gian giữa hai đợt bảo trì">
                        <template #body="slotProps">
                          <div >
                            <InputNumber :disabled="true" id="minmax-buttons" v-model="slotProps.data.time_between_maintenance" mode="decimal" showButtons :min="0" :max="100" />
                          </div>
                        </template>
                      </Column>
                      <Column
                          :bodyStyle="'width: 600;text-align: center;'"
                          :headerStyle="'width: 600px;text-align: center;'"
                          :headerClass="object_maintenance.headerClass"
                          field="list_service_pack_id" header="Gói dịch vụ bảo trì">
                        <template #body="slotProps">
                          <div >
                            <MultiSelect :disabled="true"  display="chip" style="width: 100%" v-model="slotProps.data.list_service_pack_id" :options="slotProps.data.arr_data_service_park" :filter="true" optionLabel="label" optionValue="id" />
                          </div>
                        </template>
                      </Column>
                      <template #empty>
                        Không có dữ liệu
                      </template>
                    </DataTable>
                  </div>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import templateSerialNumber from '../common/templateSerialNumber'
export default {
  components: {
    templateSerialNumber
  },
  data() {
    return {
      listData: [],
      dataModel: null,
      componentKey: 0,
      modelName: 'product_changed_log',
      model_code: '',
      name: '',
      category_id: 0,
      productionStatus: 0,
      optionStatus: [{ value: 1, label: 'Đang sản xuất'}, { value: 2, label: 'Ngưng sản xuất'}],
      qr_code_size: 'mau_2',
      qrCodeSizes: [{ value: 'mau_2', label: 'Mẫu 5x3cm'}],
      warranty_time: 0,
      change_time: 0,
      returnable_time: 0,
      returnable_appraisal_time: 0,
      optionsCategories: [],
      description: '',
      productImages: '',
      productQRCode: '',
      productID : 0,
      serialNumber: '12345678912',
      title: '',
      note: '',
      hotline: '',
      logoPortal: window.origin + '/assets/images/logo_HK-01.png',
      is_maintenance:0,
      type_maintenance:null,
      object_maintenance:{
        list_product_service_park_init_id: [],//danh sách id lúc đầu để so sánh để xóa
        list_product_service_park: [],
        list_data: [],
        list_service_park: [],
        selected_service_park: null,
        service_unit_map_data: null,
        scrollHeight: '', // chiều cao của trang danh sách
        service_total_price_service:0,
        service_total_discount:0,
        service_total_money_discount:0,
        service_tax:0,
        service_money_tax:0,
        service_total_price_payment:0,
        headerClass:'style_header',
        footerClass:'style_footer',
      },
      link_pdf:"",
      link_youtube:"",
    }
  },
  async mounted () {
    await this.categories();
    this.dataModel = DataServices.getModel(this.modelName);
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      await this.getData(Number(this.$route.params.id));
      await this.getSettings();
    }
  },
  methods: {
    async getData(id) {
      var variables = {
        where_key: {
          id: {'_eq': id }
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables), "fields": "product_id new_value"});
      var list = data[Object.keys(data)];
      
      if (list != null) {
        var model = list[0];
        this.productID = model.product_id;
        model = model.new_value;
        console.log("modelmodel:",model)
        if(model.model_code != undefined) this.model_code = model.model_code;
        if(model.link_pdf != undefined) this.link_pdf = model.link_pdf;
        if(model.link_youtube != undefined) this.link_youtube = model.link_youtube;
        if(model.category_id != undefined) this.category_id = model.category_id;
        if(model.description != undefined) this.description = model.description;
        if(model.name != undefined) this.name = model.name;
        if(model.production_status != undefined) this.productionStatus = model.production_status;
        if(model.returnable_time != undefined) this.returnable_time = model.returnable_time;
        if(model.change_time != undefined) this.change_time = model.change_time;
        if(model.returnable_appraisal_time != undefined) this.returnable_appraisal_time = model.returnable_appraisal_time;
        this.is_maintenance = (!this.$myConstants.isEmpty(model.is_maintenance)) ? model.is_maintenance:0;
        this.type_maintenance = (!this.$myConstants.isEmpty(model.type_maintenance)) ? model.type_maintenance:0;
        if(model.warranty_time != undefined) this.warranty_time = model.warranty_time;
        if(model.qr_code_size != undefined && model.qr_code_size != null) this.qr_code_size = model.qr_code_size;
        if(model.qr_path != undefined) this.productQRCode = model.qr_path;
        if(model.thumbnails != undefined ) this.productImages = (model.thumbnails.external_path != undefined  && model.thumbnails.external_path != null ? model.thumbnails.external_path : (model.thumbnails.local_path != undefined && model.thumbnails.local_path != null ? model.thumbnails.cdn_path + '' +model.thumbnails.local_path : this.logoPortal));
        //load bảo trì định kỳ
        if (!this.$myConstants.isEmpty(model.maintenance)){
          //this.object_maintenance.list_data = (model.maintenance.length >0 ) ? model.maintenance:[];
          var list_maintenance = (model.maintenance.length >0 ) ? model.maintenance:[];
          for (var i=0;i<list_maintenance.length;i++){
            var arr_data_service_park = list_maintenance[i].arr_data_service_park;
            for (var s=0;s<arr_data_service_park.length;s++){
              var code_service_park = (!this.$myConstants.isEmpty(arr_data_service_park[s].code)) ? arr_data_service_park[s].code:'';
              var name_service_park = (!this.$myConstants.isEmpty(arr_data_service_park[s].name)) ? arr_data_service_park[s].name:'';
              list_maintenance[i].arr_data_service_park[s].label = code_service_park+" - "+name_service_park;
            }
          }
          this.object_maintenance.list_data = list_maintenance;

        }
        this.componentKey++;
      }
    },
    backList() {
       this.$router.push({path: '/admin/product/history/' + this.productID });
    },
    async categories() {
      var variables = {
        where_key: {
          status: {'_in': [0,1] }
        }
      }
      var data = await DataServices.getList('categories', {"variables": JSON.stringify(variables), "fields": "id,name"});
      var list = data[Object.keys(data)];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          this.optionsCategories.push({label: item.name, value: item.id});
        }
      }
    },
    async getSettings() {
      var variables = {
        where_key: {
          key: {'_in': ['QR_SERIAL_NUMBER_TITLE', 'QR_SERIAL_NUMBER_NOTE', 'QR_SERIAL_NUMBER_HOTLINE']}
        },
        orderBy: {
          key: 'desc'
        }
      }
      var data = await DataServices.getList('settings', {"variables": JSON.stringify(variables), 'fields' : 'key value'});
      if (data != undefined && data != null && data[Object.keys(data)].length) {
        var lists = data[Object.keys(data)];
        var objTitle = lists.filter(a => a.key == 'QR_SERIAL_NUMBER_TITLE');
        if (objTitle && Object.keys(objTitle).length) {
          this.title = objTitle[0].value;
        }
        var objNote = lists.filter(a => a.key == 'QR_SERIAL_NUMBER_NOTE');
        if (objNote && Object.keys(objNote).length) {
          this.note = objNote[0].value;
        }
        var objHotline = lists.filter(a => a.key == 'QR_SERIAL_NUMBER_HOTLINE');
        if (objHotline && Object.keys(objHotline).length) {
          this.hotline = objHotline[0].value;
        }
      }
    }
  }
}
</script>
<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.box-top-list{border: 1px solid #ccc; padding: 10px; 
  span{font-size: 25px; text-align: left; display: inline-block;}
  .right-button{float: right; 
    span{font-size: 14px;}
  }
}
.list-data{border: 1px solid #ccc; border-top: 0 none; padding: 20px;
  .unit-custom{text-align: right;
    label{margin-bottom: 0; margin-top: 10px;}
  }
  .box-qrcode-product{margin-top: 20px;}
  .box-img-product{margin-top: 40px;}
}
.custom-qr-code {
  .qr-custom{width: 150px !important; height: 150px !important;}
}
</style>